import { render, staticRenderFns } from "./homepage.vue?vue&type=template&id=47c87686&scoped=true"
import script from "./homepage.vue?vue&type=script&lang=js"
export * from "./homepage.vue?vue&type=script&lang=js"
import style0 from "../../homepage-assets/css/bootstrap.min.css?vue&type=style&index=0&id=47c87686&prod&scoped=true&lang=css&external"
import style1 from "../../homepage-assets/css/animate.css?vue&type=style&index=1&id=47c87686&prod&scoped=true&lang=css&external"
import style2 from "../../homepage-assets/css/main.css?vue&type=style&index=2&id=47c87686&prod&scoped=true&lang=css&external"
import style3 from "../../homepage-assets/css/custom.css?vue&type=style&index=3&id=47c87686&prod&scoped=true&lang=css&external"
import style4 from "./homepage.vue?vue&type=style&index=4&id=47c87686&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c87686",
  null
  
)

export default component.exports